/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from 'react';
import './style.scss';
import { LoadGif } from '../LoadGif';
import { fileService } from '../customInput/fileServer';
import showToast from '../toastyService';

import { ReactComponent as ArchiveIcon } from 'src/assets/icons/archive.svg';
import { ReactComponent as Pdf } from 'src/assets/icons/oldPortal/pagina.svg';
import { ReactComponent as Reload } from 'src/assets/icons/reload.svg';
import { ReactComponent as Return } from 'src/assets/icons/return.svg';
import { ReactComponent as Add } from 'src/assets/icons/oldPortal/adicionar.svg';
import { ReactComponent as Upload } from 'src/assets/icons/upload.svg';
import { ReactComponent as Trash } from 'src/assets/icons/trash.svg';
import { ReactComponent as Rename } from 'src/assets/icons/edit.svg';
import { isValid } from 'src/services/auth';
import ExtensionIcon from '../ExtensionIcon';

export default function Documentos() {
  const [load, setLoad] = useState(false);
  const user = JSON.parse(localStorage.getItem('userDetails'));

  const [sortOrder, setSortOrder] = useState('name asc');
  const [files, setFiles] = useState([]);

  const [path, setPath] = useState([]);
  const [currentPath, setCurrentPath] = useState('');
  const [search, setSearch] = useState('');

  const [showPopup, setShowPopup] = useState('');
  const [selectedItem, setSelectedItem] = useState();
  const [renameInput, setRenameInput] = useState('');
  const [newFolderName, setNewFolderName] = useState('');

  const [filesToUpload, setFilesToUpload] = useState([]);

  const sortFiles = () => {
    const [key, order] = sortOrder.split(' ');

    return (a, b) => {
      const valA =
        key === 'name' ? a.name.toLowerCase() : new Date(a.createdAt);
      const valB =
        key === 'name' ? b.name.toLowerCase() : new Date(b.createdAt);

      if (order === 'asc') {
        return valA > valB ? 1 : valA < valB ? -1 : 0;
      } else {
        return valA < valB ? 1 : valA > valB ? -1 : 0;
      }
    };
  };

  function timedLoad(time) {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, time);
  }

  useEffect(() => {
    setCurrentPath(path.length ? '/' + path.join('/') : '/');
  }, [path]);

  useEffect(() => {
    getAllFiles();
  }, []);

  function getAllFiles() {
    setLoad(true);
    setFiles([]);

    fileService
      .listRecursiveFiles()
      .then((data) => {
        setFiles(data);
      })
      .catch((error) => showToast('error', error.message))
      .finally(setLoad(false));
  }

  function handleCreateFolder(folderName) {
    setLoad(true);
    if (!folderName) return;

    fileService
      .createFolder(currentPath, folderName)
      .then(() => {
        getAllFiles();
        setShowPopup('');
      })
      .catch((err) => showToast('error', err.message))
      .finally(() => setLoad(false));
  }

  function handleRename() {
    setLoad(true);
    if (!renameInput.trim()) {
      showToast('warning', 'Nome inválido');
      return;
    }

    const newName = renameInput.trim();
    const newPath = selectedItem.path.replace(/\/[^/]+$/, '');

    fileService
      .renameFile(newPath, selectedItem.name, newName)
      .then(() => {
        getAllFiles();
        setShowPopup('');
        setSelectedItem(null);
        setRenameInput('');
      })
      .catch((err) => {
        showToast('error', err.message);
      })
      .finally(() => timedLoad(1000));
  }

  function handleDelete() {
    if (!selectedItem) return;
    setLoad(true);
    const url = localStorage.getItem('fileServer');
    const parentPath = selectedItem.path.replace(/\/[^/]+$/, '');

    fileService
      .deleteFiles(url, parentPath, [selectedItem.name])
      .then(() => {
        getAllFiles();
        setShowPopup('');
        setSelectedItem(null);
      })
      .catch((err) => showToast('error', err.message))
      .finally(() => timedLoad(1000));
  }

  function handleUpload() {
    if (!filesToUpload.length) return;

    const url = localStorage.getItem('fileServer');
    setLoad(true);

    fileService
      .uploadFiles(url, currentPath, filesToUpload)
      .then(() => {
        showToast('success', 'Upload realizado com sucesso');
        getAllFiles();
      })
      .catch((err) => showToast('error', err.message))
      .finally(() => {
        timedLoad(1000);
        setFilesToUpload([]);
        setShowPopup('');
      });
  }

  function handleDownload(item) {
    const url = localStorage.getItem('fileServer');
    const parentPath = item.path.replace(/\/[^/]+$/, '');

    fileService
      .getFile(url, parentPath, item.name)
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = item.name;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => showToast('error', err.message));
  }

  useEffect(() => {
    if (isValid(filesToUpload)) setShowPopup('upload');
  }, [filesToUpload]);

  const renderItem = (item, index) => {
    const isDirectory = item.type === 'Directory';

    const highlightSearch = (name) => {
      if (!search) return name;

      const parts = name.split(new RegExp(`(${search})`, 'gi'));
      return parts.map((part, idx) =>
        part.toLowerCase() === search.toLowerCase() ? (
          <strong key={idx}>{part}</strong>
        ) : (
          part
        )
      );
    };

    if (isDirectory)
      return (
        <button
          key={index}
          onClick={() => setPath((prev) => [...prev, item.name])}
          className={`item ${item.type}`}
        >
          <span>
            <ArchiveIcon />
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowPopup('rename');
                setSelectedItem(item);
                setRenameInput(item.name);
              }}
              className="name"
            >
              {highlightSearch(item.name)}
            </button>
          </span>
          <span>
            {new Date(item.createdAt).toLocaleString('pt-BR', {
              hour: '2-digit',
              minute: '2-digit',
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })}
          </span>
          <span className="controls">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowPopup('rename');
                setSelectedItem(item);
                setRenameInput(item.name);
              }}
            >
              <Rename />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowPopup('delete');
                setSelectedItem(item);
              }}
            >
              <Trash />
            </button>
          </span>
        </button>
      );

    return (
      <button
        key={index}
        onClick={() => handleDownload(item)}
        className={`item ${item.type}`}
      >
        <span>
          <ExtensionIcon extension={item.name} />
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowPopup('rename');
              setSelectedItem(item);
              setRenameInput(item.name);
            }}
            className="name"
          >
            {highlightSearch(item.name)}
          </button>
        </span>
        <span>
          {new Date(item.createdAt).toLocaleString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          })}
        </span>
        <span className="controls">
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowPopup('rename');
              setSelectedItem(item);
              setRenameInput(item.name);
            }}
          >
            <Rename />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowPopup('delete');
              setSelectedItem(item);
            }}
          >
            <Trash />
          </button>
        </span>
      </button>
    );
  };

  return (
    <div className="Documentos">
      {load && <LoadGif />}

      {showPopup === 'upload' && (
        <div className="modal uploadPopup absoluteCenter mainShadow">
          <h6> Items selecionados: </h6>

          {filesToUpload.map((item, index) => (
            <span className="item" key={index}>
              <ExtensionIcon extension={item.name} />
              {item.name}
            </span>
          ))}
          <span>
            <button
              onClick={() => handleUpload()}
              className="mainButton turquoise"
            >
              Fazer Upload
            </button>
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              Cancelar
            </button>
          </span>
        </div>
      )}

      {showPopup === 'newFolder' && (
        <div className="modal absoluteCenter mainShadow">
          <input
            placeholder="Nome da Pasta"
            onChange={(e) => setNewFolderName(e.target.value)}
          />
          <span>
            <button
              onClick={() => handleCreateFolder(newFolderName)}
              className="mainButton turquoise"
            >
              Criar
            </button>
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              Cancelar
            </button>
          </span>
        </div>
      )}

      {showPopup === 'rename' && (
        <div className="modal absoluteCenter mainShadow">
          <input
            placeholder={selectedItem.name}
            value={renameInput}
            onChange={(e) => setRenameInput(e.target.value)}
          />
          <span>
            <button
              onClick={() => handleRename()}
              className="mainButton turquoise"
            >
              Renomear
            </button>
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              Cancelar
            </button>
          </span>
        </div>
      )}

      {showPopup === 'delete' && (
        <div className="modal absoluteCenter mainShadow deletePopup">
          <h6> Deletar: </h6>

          <p>
            {selectedItem.type === 'Directory' ? (
              <ArchiveIcon />
            ) : (
              <ExtensionIcon extension={selectedItem.name} />
            )}
            {selectedItem.name}
          </p>

          <span>
            <button onClick={() => handleDelete()} className="mainButton red">
              Deletar
            </button>
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              Cancelar
            </button>
          </span>
        </div>
      )}

      <div className="hotbar">
        <button
          className="mainButton turquoise"
          onClick={() => setShowPopup('newFolder')}
        >
          <Add />
          Nova pasta
        </button>

        <button
          onClick={() => document.getElementById('uploadInput').click()}
          className="mainButton yellow"
        >
          <Upload />
          Enviar arquivo
        </button>

        <input
          className="search"
          id="uploadInput"
          type="file"
          style={{ display: 'none' }}
          multiple
          onChange={(e) => setFilesToUpload(Array.from(e.target.files))}
        />

        <input
          className="search"
          type="text"
          placeholder="Buscar arquivos"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="baseInput select">
          <select
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
          >
            <option value="name asc">Nome ↑</option>
            <option value="name desc">Nome ↓</option>
            <option value="date asc">Data de criação ↑</option>
            <option value="date desc">Data de criação ↓</option>
          </select>
        </div>

        <button
          onClick={() => {
            getAllFiles();
            timedLoad(1000);
          }}
          className="mainButton turquoise reload"
        >
          <Reload />
        </button>
      </div>

      <div className="lista mainShadow">
        {(showPopup !== '' || load) && (
          <button onClick={() => setShowPopup('')} className="fade" />
        )}

        <div className="caminho">
          <button
            className="return"
            onClick={() => {
              setPath((prev) => prev.slice(0, -1));
              setSearch('');
            }}
          >
            <Return />
          </button>
          <button
            onClick={() => {
              setPath([]);
              setSearch('');
            }}
          >
            {user?.NOME}
          </button>
          {path.length > 0 &&
            path.map((item, index) => (
              <button
                key={index}
                onClick={() => {
                  setPath(path.slice(0, index + 1));
                  setSearch('');
                }}
              >
                / {item}
              </button>
            ))}
        </div>

        <div className="files">
          <div className="filesHeader">
            <span>
              <h3>Nome</h3>
            </span>
            <span>
              <h3>Data de Criação</h3>
            </span>
            <span>
              <h3>Ações</h3>
            </span>
          </div>

          {files
            .filter((file) => {
              const filePath = file.path;
              const parentPath =
                filePath.split('/').slice(0, -1).join('/') || '/';
              const matchPath = parentPath === currentPath;

              if (!search) return matchPath;

              const matchSearch = file.name
                .toLowerCase()
                .includes(search.toLowerCase());
              return matchPath && matchSearch;
            })
            .sort(sortFiles())
            .map((item, index) => renderItem(item, index))}

          {search.length > 0 && (
            <>
              <h4> Resultados em Outras Pastas </h4>
              {files
                .filter((file) => {
                  const filePath = file.path;
                  const parentPath =
                    filePath.split('/').slice(0, -1).join('/') || '/';
                  const matchPath = parentPath === currentPath;

                  const matchSearch = file.name
                    .toLowerCase()
                    .includes(search.toLowerCase());
                  return !matchPath && matchSearch;
                })
                .map((item, index) => renderItem(item, index))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
